import { connect } from 'react-redux';
import { addonSelector, getActiveTabInSidePanel } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { changeTabInSidePanel } from 'state/uiPanelState/sidePanelUi/sidePanelUi.action';
import { SidePanelTabId } from 'state/uiPanelState/sidePanelUi/sidePanelUi.model';

export interface OwnProps {
  tabId: string;
}
export interface StateProps {
  activeTab: SidePanelTabId;
  hasGreeks: boolean;
  hasFees: boolean;
  hasMetrics: boolean;
}

interface DispatchProps {
  selectTab: (activeTab: SidePanelTabId) => void;
}

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const activeTab = getActiveTabInSidePanel(state, tabId);

  return {
    hasGreeks: addonSelector.hasGreeks(state, tabId),
    hasFees: addonSelector.hasFees(state, tabId),
    hasMetrics: addonSelector.hasMetrics(state, tabId),
    activeTab,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    selectTab: activeTab => {
      dispatch(changeTabInSidePanel(tabId, activeTab));
    },
  };
};

export type SidePanelProps = StateProps & OwnProps & DispatchProps;
export const connectSidePanel = connect(mapStateToProps, mapDispatchToProps);
